import classNames from 'classnames';
import type { FC } from 'react';
import React from 'react';

import Button from '../../../../../../../common/components/Button';
import type { DataHook } from '../../../../../../../types';
import type { SubmitButtonClickHandler } from '../../types';
import styles from './CustomButton.scss';

type CustomButtonProps = {
  title: string;
  onClick: SubmitButtonClickHandler;
  dataHook?: DataHook;
  className?: string;
  isSecondary?: boolean;
  isDisabled?: boolean;
};

export const CustomButton: FC<CustomButtonProps> = ({
  title,
  onClick,
  dataHook,
  className,
  isSecondary = false,
  isDisabled = false,
}) => {
  const baseClassName = classNames(styles.mainButtonElement, className);
  const buttonClassName = isSecondary
    ? classNames(baseClassName, styles.buttonSecondary)
    : classNames(baseClassName, styles.buttonPrimary);

  const handleButtonClick: SubmitButtonClickHandler = (event) => {
    event.preventDefault();
    onClick(event);
  };

  return (
    <Button
      dataHook={dataHook}
      className={buttonClassName}
      isDisabled={isDisabled}
      onClick={handleButtonClick}
    >
      {title}
    </Button>
  );
};
